// Video Reviews JS
document.addEventListener('DOMContentLoaded', function () {

  const imageWithTextSlider = new Swiper(".image-wth-text-img-slides", {
    spaceBetween: 17,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    speed: 1000,
    loop: true, 
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      480: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 1
      }
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });

  
  /******VIDEO PLAYING FUNCTIONALITY*****/
  const playTriggers = document.querySelectorAll("[playTrigger]");
  playTriggers.forEach(function (playButton) {
    playButton.addEventListener("click", function () {
      const video = this.closest("[videoWrapper]").querySelector("video");
      video.play();
      this.classList.add("hidden");
    });
  });

  const videoElements = document.querySelectorAll("[videoWrapper] video");
  videoElements.forEach(function (video) {
    video.addEventListener("click", function () {
      if (!this.paused && !this.ended) {
        this.pause();
        this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
      }
    });

    video.addEventListener("ended", function () {
      const playButton = this.closest("[videoWrapper]").querySelector("[playTrigger]");
      playButton.classList.remove("hidden");
      this.load();
    });
  });
});
//     // Sticky image image with text
// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       threshold: [0.5, 1]
//     }
//     const targets = document.querySelectorAll('.cb');
//     const locker = document.querySelector('.locker__container');

//     function handleIntersection(entries) {
//       entries.map((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);
        
//         if (entry.isIntersecting) {
//           entry.target.current = entry.target.dataset.swap;
//           element.classList.add("active");
//         } else {
//           element.classList.remove("active");
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));
//   } else {
//     // Fallback
//   }
// });
//  Second Working Script 
// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       threshold: [0.5, 1] // Adjust the threshold as needed
//     };

//     const targets = document.querySelectorAll('.cb');
//     const locker = document.querySelector('.locker__container');

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);
        
//         if (entry.isIntersecting) {
//           entry.target.current = entry.target.dataset.swap;
//           element.classList.add("active");
//         } else {
//           element.classList.remove("active");
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));
//   } else {
//     // Fallback for unsupported browsers
//   }
// });

// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       threshold: [0, 1] // Trigger when 0% to 100% of the element is visible
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting) {
//           element.classList.add("active");
//         } else {
//           // Check if the entire block is out of view to remove the active class
//           if (entry.intersectionRatio === 0) {
//             element.classList.remove("active");
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });


// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       threshold: [0.5, 1] // Trigger when 50% or more of the element is visible
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting) {
//           element.classList.add("active");
//         } else {
//           // Remove the active class if less than 50% of the block is visible
//           if (entry.intersectionRatio < 0.5) {
//             element.classList.remove("active");
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });
/////////////////////////////////////////////////////////////////////


// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       threshold: [0.5, 1] // Trigger when 50% or more of the element is visible
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images

//     let timeout;

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting) {
//           element.classList.add("active");
          
//           // Clear the timeout if it's already set
//           if (timeout) {
//             clearTimeout(timeout);
//             timeout = null;
//           }
//         } else {
//           // Set a timeout to remove the class after a delay
//           if (entry.intersectionRatio < 0.5) {
//             timeout = setTimeout(() => {
//               element.classList.remove("active");
//             }, 300); // Adjust the delay time as needed
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });
//  Above Old Solution
////////////////////////////
// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       rootMargin: '0px 0px -600px 0px', // Trigger when 600px of the element's bottom is within the viewport
//       threshold: [0] // Trigger as soon as any part of the element is visible within the rootMargin
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images

//     let timeout;

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting) {
//           element.classList.add("active");
          
//           // Clear the timeout if it's already set
//           if (timeout) {
//             clearTimeout(timeout);
//             timeout = null;
//           }
//         } else {
//           // Set a timeout to remove the class after a delay
//           if (entry.boundingClientRect.height < 600) {
//             timeout = setTimeout(() => {
//               element.classList.remove("active");
//             }, 300); // Adjust the delay time as needed
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });

// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       rootMargin: '0px 0px -600px 0px', // Trigger when the element's bottom is within 600px of the viewport
//       threshold: [0] // Trigger when any part of the element is visible
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images

//     let timeout;

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight) {
//           // When the element is entering the viewport (scroll down or scroll up)
//           element.classList.add("active");

//           // Clear the timeout if already set
//           if (timeout) {
//             clearTimeout(timeout);
//             timeout = null;
//           }
//         } else if (!entry.isIntersecting) {
//           // Handle the first element remaining visible when scrolling to the top
//           if (entry.target === targets[0] && window.scrollY === 0) {
//             element.classList.add("active");
//           }
//           // Handle the last element remaining visible at the bottom
//           else if (entry.target === targets[targets.length - 1] && window.innerHeight + window.scrollY >= document.body.scrollHeight) {
//             element.classList.add("active");
//           } else {
//             // Remove the active class when the element goes out of view (scrolling)
//             timeout = setTimeout(() => {
//               element.classList.remove("active");
//             }, 300); // Delay for removing 'active' class
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });

// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       rootMargin: '0px 0px -600px 0px', // Trigger when the element's bottom is within 600px of the viewport
//       threshold: [0] // Trigger when any part of the element is visible
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images

//     let timeout;

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight) {
//           // When the element is entering the viewport (scroll down or scroll up)
//           element.classList.add("active");

//           // Clear the timeout if already set
//           if (timeout) {
//             clearTimeout(timeout);
//             timeout = null;
//           }
//         } else if (!entry.isIntersecting) {
//           // Always keep the first image visible when scrolling to the top
//           if (entry.target === targets[0] && window.scrollY === 0) {
//             element.classList.add("active");
//           } else {
//             // Remove the active class when the element goes out of view (scrolling)
//             timeout = setTimeout(() => {
//               element.classList.remove("active");
//             }, 300); // Delay for removing 'active' class
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));

//     // Keep the first image active on initial page load if we're at the top
//     const firstImage = document.querySelector(".locker__container .image--1");
//     if (window.scrollY === 0) {
//       firstImage.classList.add("active");
//     }
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });



// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       rootMargin: '0px 0px -700px 0px', // Trigger when the element's bottom is within 600px of the viewport
//       threshold: [0] // Trigger when any part of the element is visible
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images

//     let timeout;

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight) {
//           // When the element is entering the viewport (scroll down or scroll up)
//           element.classList.add("active");

//           // Clear the timeout if already set
//           if (timeout) {
//             clearTimeout(timeout);
//             timeout = null;
//           }
//         } else if (!entry.isIntersecting) {
//           // Always keep the first image active when scrolling near the top
//           if (entry.target === targets[0] && window.scrollY <= 200) {
//             element.classList.add("active");
//           } else {
//             // Remove the active class when the element goes out of view (scrolling)
//             timeout = setTimeout(() => {
//               element.classList.remove("active");
//             }, 300); // Delay for removing 'active' class
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));

//     // Always keep the first image active on page load if we're near the top
//     const firstImage = document.querySelector(".locker__container .image--1");
//     if (window.scrollY <= 200) {
//       firstImage.classList.add("active");
//     }

//     // Listen for scroll events and make sure first image stays active near the top
//     window.addEventListener('scroll', function () {
//       if (window.scrollY <= 200) {
//         firstImage.classList.add("active");
//       }
//     });
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });

// document.addEventListener('DOMContentLoaded', function () {
//     console.log("scroll code");
//   if (typeof window.IntersectionObserver !== 'undefined') {
//     let options = {
//       rootMargin: '0px 0px -600px 0px', // Trigger when the element's bottom is within 700px of the viewport
//       threshold: [0] // Trigger when any part of the element is visible
//     };

//     const targets = document.querySelectorAll('.cb'); // Content blocks
//     const locker = document.querySelector('.locker__container'); // Container for images
//     const firstTarget = targets[0]; // First content block
//     const lastTarget = targets[targets.length - 1]; // Last content block

//     let timeout;

//     function handleIntersection(entries) {
//       entries.forEach((entry) => {
//         const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//         if (entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight) {
//           // When the element is entering the viewport (scroll down or scroll up)
//           element.classList.add("active");

//           // Clear the timeout if already set
//           if (timeout) {
//             clearTimeout(timeout);
//             timeout = null;
//           }
//         } else if (!entry.isIntersecting) {
//           // Keep the first image active when scrolling near the top
//           if (entry.target === firstTarget && window.scrollY <= 200) {
//             element.classList.add("active");
//           }
//           // Keep the last image active when scrolling near the bottom
//           else if (entry.target === lastTarget && (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
//             element.classList.add("active");
//           } else {
//             // Remove the active class when the element goes out of view (scrolling)
//             timeout = setTimeout(() => {
//               element.classList.remove("active");
//             }, 300); // Delay for removing 'active' class
//           }
//         }
//       });
//     }

//     const observer = new IntersectionObserver(handleIntersection, options);
//     targets.forEach(target => observer.observe(target));

//     // Always keep the first image active on page load if we're near the top
//     const firstImage = document.querySelector(".locker__container .image--1");
//     if (window.scrollY <= 200) {
//       firstImage.classList.add("active");
//     }

//     // Listen for scroll events and make sure first and last images stay active near the top/bottom
//     window.addEventListener('scroll', function () {
//       if (window.scrollY <= 200) {
//         firstImage.classList.add("active");
      
//       }

//       const lastImage = document.querySelector(".locker__container ." + lastTarget.dataset.swap);
//       if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
//         lastImage.classList.add("active");
//       }
//     });
//   } else {
//     // Fallback for unsupported browsers
//     console.log('IntersectionObserver is not supported in this browser.');
//   }
// });




// document.addEventListener('DOMContentLoaded', function () {
//   console.log("scroll code");

//   const targets = document.querySelectorAll('.cb'); // Content blocks
//   const locker = document.querySelector('.locker__container'); // Container for images

//   // Check if necessary elements exist
//   if (targets.length === 0 || !locker) {
//     console.error("Required elements '.cb' or '.locker__container' are missing.");
//     return;
//   }

//   const firstTarget = targets[0]; // First content block
//   const lastTarget = targets[targets.length - 1]; // Last content block

//   // Fallback for unsupported browsers
//   if (typeof window.IntersectionObserver === 'undefined') {
//     console.log('IntersectionObserver is not supported in this browser.');
//     return;
//   }

//   let options = {
//     rootMargin: '0px 0px -600px 0px', // Trigger when the element's bottom is within 700px of the viewport
//     threshold: [0] // Trigger when any part of the element is visible
//   };

//   let timeout;

//   function handleIntersection(entries) {
//     entries.forEach((entry) => {
//       const element = document.querySelector(".locker__container ." + entry.target.dataset.swap);

//       // Check if the element with corresponding class exists
//       if (!element) {
//         console.error("Element with class '" + entry.target.dataset.swap + "' not found.");
//         return;
//       }

//       if (entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight) {
//         // Element is entering the viewport
//         element.classList.add("active");

//         // Clear the timeout if already set
//         if (timeout) {
//           clearTimeout(timeout);
//           timeout = null;
//         }
//       } else if (!entry.isIntersecting) {
//         // Keep the first image active when scrolling near the top
//         if (entry.target === firstTarget && window.scrollY <= 200) {
//           element.classList.add("active");
//         }
//         // Keep the last image active when scrolling near the bottom
//         else if (entry.target === lastTarget && (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
//           element.classList.add("active");
//         } else {
//           // Remove the active class when the element goes out of view
//           timeout = setTimeout(() => {
//             element.classList.remove("active");
//           }, 300); // Delay for removing 'active' class
//         }
//       }
//     });
//   }

//   const observer = new IntersectionObserver(handleIntersection, options);
//   targets.forEach(target => observer.observe(target));

//   // Always keep the first image active on page load if we're near the top
//   const firstImage = document.querySelector(".locker__container .image--1");
//   if (window.scrollY <= 200) {
//     firstImage.classList.add("active");
//   }

//   // Listen for scroll events and make sure first and last images stay active near the top/bottom
//   window.addEventListener('scroll', function () {
//     if (window.scrollY <= 200) {
//       firstImage.classList.add("active");
//     }

//     const lastImage = document.querySelector(".locker__container ." + lastTarget.dataset.swap);
//     if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
//       lastImage.classList.add("active");
//     }
//   });
// });






